import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	PermissionName,
	currentUserHasAccess,
} from '@netx/core-permissions-next/enablers';
import {currentCartIsEmpty} from './currentCartIsEmpty';

export const canCreateShareLinkPdfFromCurrentCart = (): boolean => {
	if (currentCartIsEmpty()) return false;
	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	return currentUserHasAccess(PermissionName.CREATE_SHARE_LINKS);
};
